import { listClasses } from "@mui/material/List";
// hooks
import { useResponsive } from "src/hooks/use-responsive";
// theme
import { paper } from "src/theme/css";

// ----------------------------------------------------------------------

export default function Popover(theme) {
    const isDesktop = useResponsive("up", "sm");

    return {
        MuiPopover: {
            styleOverrides: {
                paper: {
                    ...paper({ theme, dropdown: true }),
                    [`& .${listClasses.root}`]: {
                        paddingTop: 0,
                        paddingBottom: 0
                    },
                    ...( isDesktop
                        ? {}
                        : {
                            "&.MuiPaper-root": {
                                maxWidth: "calc(47.5% - 16px)",
                                width: "100%",
                                wordBreak: "break-word",
                                overflowWrap: "break-word"
                            }
                        } )
                }
            }
        }
    };
}
